module.exports = __webpack_public_path__ + "media/images/products/demo/headphone-b947e85c45be78ffd4dc266b01988bf0.jpg";